// extracted by mini-css-extract-plugin
export default {"root":"SegmentControl_root__dSwDE","segment":"SegmentControl_segment__PumV6","segmentLabel":"SegmentControl_segmentLabel__9cUjA"};